'use client';

import React from 'react';
import { Button } from '@/shared/ui/shadcn/button';
import { Card, CardContent } from '@/shared/ui/shadcn/card';
import { cn } from '@/shared/lib/cn';
import { Typography } from '@/shared/ui/shadcn/typography';

interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: React.ReactNode;
  action?: {
    label: string;
    onClick: () => void;
  };
  secondaryAction?: {
    label: string;
    onClick: () => void;
  };
  className?: string;
  withCard?: boolean;
  centered?: boolean;
}

export function EmptyState({
  icon,
  title,
  description,
  action,
  secondaryAction,
  className = '',
  withCard = false,
  centered = false,
}: EmptyStateProps) {
  const content = (
    <div
      className={cn(
        'flex flex-col items-center justify-center p-8 text-center',
        centered ? 'min-h-[50vh]' : 'py-16',
        className
      )}
    >
      {icon && (
        <div className="mb-4 text-muted-foreground/50 [&>svg]:h-12 [&>svg]:w-12">
          {icon}
        </div>
      )}

      <Typography variant="h5" className="mb-2">
        {title}
      </Typography>

      {description && (
        <Typography variant="muted" className="mb-6 max-w-md">
          {description}
        </Typography>
      )}

      {(action || secondaryAction) && (
        <div className="flex flex-col sm:flex-row gap-3">
          {action && (
            <Button onClick={action.onClick} variant="default">
              {action.label}
            </Button>
          )}

          {secondaryAction && (
            <Button onClick={secondaryAction.onClick} variant="secondary">
              {secondaryAction.label}
            </Button>
          )}
        </div>
      )}
    </div>
  );

  if (withCard) {
    return (
      <Card>
        <CardContent className="p-0">{content}</CardContent>
      </Card>
    );
  }

  return content;
}
